/**
 * i18next setup for Frac. React-i18next chosen for maturity, small bundle
 * footprint and zero runtime dependencies on the router.
 *
 * Namespaces mirror the JSON files in /src/locales/{en,zh}/*.json — split
 * per-surface so we can lazy-load them later without a rewrite.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enAwards from "@/locales/en/awards.json";
import enNav from "@/locales/en/nav.json";
import enHome from "@/locales/en/home.json";
import enFooter from "@/locales/en/footer.json";
import enCompany from "@/locales/en/company.json";
import enNotFound from "@/locales/en/notFound.json";
import enCommon from "@/locales/en/common.json";
import enPlatform from "@/locales/en/platform.json";
import enPlatformMarketing from "@/locales/en/platformMarketing.json";
import enPlatformAi from "@/locales/en/platformAi.json";
import enPlatformData from "@/locales/en/platformData.json";
import enPlatformEnergy from "@/locales/en/platformEnergy.json";
import enPlatformTokenization from "@/locales/en/platformTokenization.json";
import enIntelligence from "@/locales/en/intelligence.json";
import enSolutions from "@/locales/en/solutions.json";
import enNewsroom from "@/locales/en/newsroom.json";
import enContact from "@/locales/en/contact.json";
import enVerifiedDocuments from "@/locales/en/verifiedDocuments.json";

import zhAwards from "@/locales/zh/awards.json";
import zhNav from "@/locales/zh/nav.json";
import zhHome from "@/locales/zh/home.json";
import zhFooter from "@/locales/zh/footer.json";
import zhCompany from "@/locales/zh/company.json";
import zhNotFound from "@/locales/zh/notFound.json";
import zhCommon from "@/locales/zh/common.json";
import zhPlatform from "@/locales/zh/platform.json";
import zhPlatformMarketing from "@/locales/zh/platformMarketing.json";
import zhPlatformAi from "@/locales/zh/platformAi.json";
import zhPlatformData from "@/locales/zh/platformData.json";
import zhPlatformEnergy from "@/locales/zh/platformEnergy.json";
import zhPlatformTokenization from "@/locales/zh/platformTokenization.json";
import zhIntelligence from "@/locales/zh/intelligence.json";
import zhSolutions from "@/locales/zh/solutions.json";
import zhNewsroom from "@/locales/zh/newsroom.json";
import zhContact from "@/locales/zh/contact.json";
import zhVerifiedDocuments from "@/locales/zh/verifiedDocuments.json";

export const NAMESPACES = [
  "awards",
  "nav",
  "home",
  "footer",
  "company",
  "notFound",
  "common",
  "platform",
  "platformMarketing",
  "platformAi",
  "platformData",
  "platformEnergy",
  "platformTokenization",
  "intelligence",
  "solutions",
  "newsroom",
  "contact",
  "verifiedDocuments",
];

const resources = {
  en: {
    awards: enAwards,
    nav: enNav,
    home: enHome,
    footer: enFooter,
    company: enCompany,
    notFound: enNotFound,
    common: enCommon,
    platform: enPlatform,
    platformMarketing: enPlatformMarketing,
    platformAi: enPlatformAi,
    platformData: enPlatformData,
    platformEnergy: enPlatformEnergy,
    platformTokenization: enPlatformTokenization,
    intelligence: enIntelligence,
    solutions: enSolutions,
    newsroom: enNewsroom,
    contact: enContact,
    verifiedDocuments: enVerifiedDocuments,
  },
  zh: {
    awards: zhAwards,
    nav: zhNav,
    home: zhHome,
    footer: zhFooter,
    company: zhCompany,
    notFound: zhNotFound,
    common: zhCommon,
    platform: zhPlatform,
    platformMarketing: zhPlatformMarketing,
    platformAi: zhPlatformAi,
    platformData: zhPlatformData,
    platformEnergy: zhPlatformEnergy,
    platformTokenization: zhPlatformTokenization,
    intelligence: zhIntelligence,
    solutions: zhSolutions,
    newsroom: zhNewsroom,
    contact: zhContact,
    verifiedDocuments: zhVerifiedDocuments,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // Bootstrap in English; <LocaleProvider> flips it based on URL.
  fallbackLng: "en",
  ns: NAMESPACES,
  defaultNS: "common",
  interpolation: { escapeValue: false }, // React already escapes.
  returnEmptyString: false,
  react: { useSuspense: false },
  // Warn when a Chinese key is missing — in dev only.
  saveMissing: false,
  missingKeyHandler: (lngs, ns, key) => {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn(`[i18n] Missing key: ${lngs}/${ns}:${key}`);
    }
  },
});

export default i18n;
